export default "__VITE_ASSET__0tfJ1IATSKuUy5GMnGNo6w__"